var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('div',{staticClass:"text-dark text-rothek font-24",domProps:{"innerHTML":_vm._s(_vm.question.question.name)}}),_c('test-question-count',{attrs:{"current-key":_vm.currentKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }